// Store global pour la sélection multiple d'écritures comptables.
// Utilisé par les checkboxes EntryRow + BulkToolbar.

import { create } from "zustand";

interface SelectionStore {
  selectedIds: Set<number>;
  toggle: (id: number) => void;
  select: (id: number) => void;
  deselect: (id: number) => void;
  selectMany: (ids: number[]) => void;
  clear: () => void;
  has: (id: number) => boolean;
  size: () => number;
}

export const useSelectionStore = create<SelectionStore>((set, get) => ({
  selectedIds: new Set<number>(),
  toggle: (id) =>
    set((state) => {
      const next = new Set(state.selectedIds);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return { selectedIds: next };
    }),
  select: (id) =>
    set((state) => {
      const next = new Set(state.selectedIds);
      next.add(id);
      return { selectedIds: next };
    }),
  deselect: (id) =>
    set((state) => {
      const next = new Set(state.selectedIds);
      next.delete(id);
      return { selectedIds: next };
    }),
  selectMany: (ids) =>
    set((state) => {
      const next = new Set(state.selectedIds);
      for (const id of ids) next.add(id);
      return { selectedIds: next };
    }),
  clear: () => set({ selectedIds: new Set<number>() }),
  has: (id) => get().selectedIds.has(id),
  size: () => get().selectedIds.size,
}));
